import type {StoreFrontMessage} from '../types/storeFrontMessage';

export const enUs: StoreFrontMessage = {
  productPage: {
    customiseButton: 'Customize',
  },
};
